module.exports = __webpack_public_path__ + "static/media/sd.00f69aca.svg";